export enum ModalType {
    DYNAMIC = 'DYNAMIC',
    CONFIRMATION = 'CONFIRMATION',
    DOCUMENT_RESULTS = 'DOCUMENT_RESULTS',
    ASSETS_AGENT = 'ASSETS_AGENT',
    DOCUMENT_RETRIEVERS = 'DOCUMENT_RETRIEVERS'
}


export interface ModalTypeData<Data> {
    type: ModalType;
    data: Data;
}
